// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FqGF","col":"styles_col__1bG7K"};